<div class="all-in-one-table content-layout" *ngIf="read">

  <div *ngIf="type==1">

    <calsoft-page-header *ngIf="secondaryType==1" [height]="'180px'"
      background="url(assets/images/headers/pattern-3.png)" [reverse]="true">
    </calsoft-page-header>
  </div>

  <div class="container">
    <div *ngIf="type==1">
      <calsoft-breadcrumbs [attr.guide]="sanitizedUrl + '-breadcrumbs'" *ngIf="secondaryType==1" [url]="'deals'"
        [currentPage]="'Deals'" [header]="'primary'"></calsoft-breadcrumbs>
    </div>
  </div>

  <div *ngIf="GridType<8 " class="container">

    <calsoft-list [type]="1" [progress]="spinner" name="Deals" [filterSelectObj]="filterSelectObj" [columns]="columns"
      (filterChangeColumn)="onFilterChangeColumn($event, 1)" (filterChange)="onFilterChange($event, 1)">
      <div (click)="bulkUpload ? restritionPopup() : null" class="actions" fxFlexAlign="center">
        <div [ngClass]="{ overlayProduct:bulkUpload }" fxLayout.lt-md="row">
          <button [attr.guide]="sanitizedUrl + '-view-headline-btn'" mat-button [matMenuTriggerFor]="menu">
            <mat-icon>view_headline</mat-icon>
            <mat-icon>arrow_drop_down</mat-icon>
          </button>

          <mat-menu [overlapTrigger]="false" xPosition="before" #menu="matMenu">
            <a [attr.guide]="sanitizedUrl + '-import-excel-advance-lnk'" mat-menu-item (click)="importExcelAdvance()">
              <mat-icon class="material-icons-outlined mat-icon-sm">import_export</mat-icon>
              <span>Import-Excel-Advance</span>
            </a>
          </mat-menu>

          <button [attr.guide]="sanitizedUrl + '-more-vert-btn'" mat-icon-button [matMenuTriggerFor]="menuTwo">
            <mat-icon>more_vert</mat-icon>
          </button>

          <!-- <ng-container *ngIf="!isMobile">
            <button [attr.guide]="sanitizedUrl + '-deal-view-btn'" mat-flat-button class="list-view-btn padding-button" (click)="selectView('dealView')">
              Deal View
            </button>
            <button [attr.guide]="sanitizedUrl + '-kanban-board-btn'" mat-flat-button class="kanban-btn padding-button" (click)="switchView('kanban')">
              Kanban Board
            </button>
          </ng-container> -->
        </div>

      </div>
      <mat-menu #menuTwo="matMenu">
        <button [attr.guide]="sanitizedUrl + '-menu-deal-view-btn'" mat-menu-item (click)="selectView('dealView')">Deal
          View</button>
        <button [attr.guide]="sanitizedUrl + '-menu-kanban-board-btn'" mat-menu-item
          (click)="switchView('kanban')">Kanban Board</button>
      </mat-menu>


      <div class="actions" fxFlexAlign="center" *ngIf="!productLimitedRestriction">
        <button [attr.guide]="sanitizedUrl + '-add-deal-btn'" [disabled]="!resourcePrivilege?.create" class="create"
          (click)="addproduct()" type="button" mat-mini-fab color="primary">
          <mat-icon>add</mat-icon>
        </button>
      </div>

      <div class="actions" fxFlexAlign="center" (click)="restritionPopup()" *ngIf="productLimitedRestriction">
        <button [attr.guide]="sanitizedUrl + '-restricted-add-deal-btn'" [disabled]="pageList>=
            productLimitedRestrictionValue" class="create" (click)="addproduct()" type="button" mat-mini-fab
          color="primary">
          <mat-icon>add</mat-icon>
        </button>
      </div>

      <calsoft-dealskanban *ngIf="viewType === 'kanban'"></calsoft-dealskanban>
      <mat-menu [overlapTrigger]="false" xPosition="before" #menu="matMenu">
        <a [attr.guide]="sanitizedUrl + '-export-excel-template-lnk'" mat-menu-item (click)="exportExcel()">
          <mat-icon class="material-icons-outlined mat-icon-sm">cloud_download</mat-icon>
          <span>Export-Excel-Template</span>
        </a>
        <a [attr.guide]="sanitizedUrl + '-import-excel-lnk'" mat-menu-item (click)="importExcel()">
          <mat-icon class="material-icons-outlined mat-icon-sm">import_export</mat-icon>
          <span>Import-Excel</span>
        </a>

        <a [attr.guide]="sanitizedUrl + '-export-data-filter-lnk'" mat-menu-item
          (click)="bulkUpload ? restritionPopup() : exportDataFilter()">
          <mat-icon>cloud_download</mat-icon>
          <span>Download</span>
        </a>

        <!-- <div *ngIf="selectionLead.length>0">
            <a [attr.guide]="sanitizedUrl + '-export-data-selected-lnk'" mat-menu-item (click)="exportDataFilterSelected('selected')">
              <mat-icon class="material-icons-outlined mat-icon-sm">cloud_download</mat-icon>
              <span>Download Selected</span>
            </a>
          </div> -->

        <!-- <div *ngIf="selectionLead.length>0">
            <a [attr.guide]="sanitizedUrl + '-transfer-lead-lnk'" mat-menu-item (click)="transferLead()">
              <mat-icon class="material-icons-outlined mat-icon-sm">transfer_within_a_station</mat-icon>
              <span>Transfer</span>
            </a>
          </div> -->

        <ng-container *ngIf="resourcePrivilege?.delete">
          <button [attr.guide]="sanitizedUrl + '-delete-all-btn'" mat-menu-item (click)="deleteAllDialog()">
            <mat-icon class="material-icons-outlined mat-icon-sm">delete_forever</mat-icon>
            <span> Delete All </span>
          </button>
        </ng-container>


      </mat-menu>
      <div *ngIf="viewType != 'kanban'">
        <div style="overflow-x:auto;">

          <table (matSortChange)="sortData($event)" [dataSource]="productList"
            [class.w-full]="!(url.includes('leadDetail') && leadDetailPageType == 0 && !isMobile)"
            [style.width]="(url.includes('leadDetail') && leadDetailPageType == 0 && !isMobile) ? '175%' : null"
            mat-table matSort>



            <!-- fullName Column -->
            <ng-container *ngFor="let column of columns">

              <ng-container *ngIf="column.isModelProperty!='false'">

                <ng-container
                  *ngIf="column.isModelProperty && column.property!='actions' && !isStaticColumn(column.property)"
                  [matColumnDef]="column.property">


                  <mat-header-cell *matHeaderCellDef mat-sort-header class="headcell"> {{ column.name }}
                  </mat-header-cell>
                  <mat-cell [ngClass]="column.cssClasses" class="cellmat" *matCellDef="let row">

                    <span *ngIf="column.property.includes('customValuesIs')">
                      {{row.isCustomizedValue[column.propertyName] }}

                    </span>
                    <span *ngIf="!column.property.includes('customValuesIs')
                        &&column.name!='Follow Up Data Time';else other_content">
                      {{row[column.property] }}

                    </span>
                    <ng-template #other_content>

                      {{row[column.property] | date:'medium'}}
                    </ng-template>


                  </mat-cell>
                </ng-container>
              </ng-container>
            </ng-container>


            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
              <mat-cell style="padding: 0 10px 0 10px;" *matCellDef="let row">
                {{(row.name) | slice:0:20}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="ownerEmail">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Owner Email</mat-header-cell>
              <mat-cell style="padding: 0 10px 0 10px;" *matCellDef="let row">
                {{(row.ownerEmail) || row.dealsOwner}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="dealsOwner">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Sales Owner</mat-header-cell>
              <mat-cell style="padding: 0 10px 0 10px;" *matCellDef="let row">
                {{(row.dealsOwner) || row.ownerEmail || '--'}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="dealsName">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Deals Name</mat-header-cell>
              <mat-cell style="padding: 0 10px 0 10px;" *matCellDef="let element">
                <div class="user-cell" fxLayout="row" fxLayoutAlign="space-between center" style="width: 100%;">

                  <div fxLayout="row" fxLayoutAlign="start center" style="flex: 1; overflow: hidden; min-width: 0;">
                    <img *ngIf="element.avatarUrl" [src]="element.avatarUrl" class="contact-avatar" />
                    <div *ngIf="!element.avatarUrl" class="contact-avatar owner-avatar" style="margin-right: 10px;">
                      {{ getInitialsTwo(element.dealsName || element.ownerIdName) }}
                    </div>
                    <span (click)="openLeadPanel(element)" class="name-cell" [attr.guide]="'link-deal-name'"
                      style="cursor:pointer; color: #002244; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-weight: 500;">
                      {{ (element.dealsName || '(No Name)') | slice:0:20 }}
                    </span>
                  </div>

                  <div class="cell-actions" fxLayout="row" fxLayoutAlign="end center" style="padding-left: 10px;">
                    <button mat-icon-button [matTooltip]="isMobile ? '' : 'Open'"
                      [matTooltipPosition]="isMobile ? '' : 'above'"
                      (click)="openLeadPanel(element); $event.stopPropagation()" class="icon-color icon-hover">
                      <mat-icon style="font-size: 17px; color: #002244;">open_in_new</mat-icon>
                    </button>

                    <button mat-icon-button [matTooltip]="isMobile ? '' : 'Send Whatsapp'"
                      [matTooltipPosition]="isMobile ? '' : 'above'"
                      (click)="phonewhatsapp(element); $event.stopPropagation()" class="icon-color icon-hover">
                      <mat-icon style="font-size: 17px; margin-top: -8px; color: #002244;"
                        [icIcon]="icWhatsapp"></mat-icon>
                    </button>
                  </div>

                </div>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="select">
              <mat-header-cell *matHeaderCellDef>
                <span>

                </span>
              </mat-header-cell>
              <mat-cell style="width: 100px;;" *matCellDef="let row">
                <mat-checkbox [attr.guide]="sanitizedUrl + '-checkbox-' + row.entityId"
                  (click)="$event.stopPropagation()" (change)="changeValue($event.checked,row)"
                  [checked]="selectionLead.indexOf(row.entityId) >= 0" [aria-label]="checkboxLabel(row.entityId)">
                </mat-checkbox>

              </mat-cell>
            </ng-container>



            <ng-container matColumnDef="closingDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Closing Date</mat-header-cell>
              <mat-cell style="width: 100px;;padding: 0 10px 0 10px;" *matCellDef="let row">
                {{(row.closingDate) | date:'dd-MM-yyyy' }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="expectedClosingDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Expected Closing Date</mat-header-cell>
              <mat-cell style="width: 100px;;padding: 0 10px 0 10px;" *matCellDef="let row">
                {{(row.expectedClosingDate) | date:'dd-MM-yyyy' }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="leadCreatedDate">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Lead Created Date</mat-header-cell>
              <mat-cell style="width: 100px;;padding: 0 10px 0 10px;" *matCellDef="let row">
                {{(row.leadCreatedDate) | date:'dd-MM-yyyy' }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="activityCountOnLead">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Activity Count</mat-header-cell>
              <mat-cell style="width: 100px;padding: 0 10px 0 10px;" *matCellDef="let row">
                <p fxFlex="100" fxLayoutAlign="center center">
                  {{(row.activityCountOnLead) }}
                </p>
              </mat-cell>
            </ng-container>


            <ng-container matColumnDef="createdDate">
              <mat-header-cell style="width: 100px" *matHeaderCellDef mat-sort-header>Created Date</mat-header-cell>
              <mat-cell style="width: 100px;padding: 0 10px 0 10px;" *matCellDef="let row">
                {{(row.createdDate) | date:'dd-MM-yyyy' }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="updatedDate">
              <mat-header-cell style="width: 100px" *matHeaderCellDef mat-sort-header>Updated Date</mat-header-cell>
              <mat-cell style="width: 100px;padding: 0 10px 0 10px;" *matCellDef="let row">
                {{(row.updatedDate) | date:'dd-MM-yyyy' }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="adGroupName">
              <mat-header-cell style="width: 100px;;" *matHeaderCellDef mat-sort-header>Campaign Name</mat-header-cell>
              <mat-cell style="width: 100px;padding: 0 10px 0 10px;" *matCellDef="let row">
                {{ row.jsonRecieved?.adGroupName!=null?row.jsonRecieved?.adGroupName:row.campaignName}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Country">
              <mat-header-cell style="width: 100px;" *matHeaderCellDef mat-sort-header>Country</mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{(row.isCustomizedValue.Country)}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="City">
              <mat-header-cell *matHeaderCellDef mat-sort-header>City</mat-header-cell>
              <mat-cell style="width: 100px;" *matCellDef="let row">
                {{(row.isCustomizedValue.City)}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="State">
              <mat-header-cell *matHeaderCellDef mat-sort-header>State</mat-header-cell>
              <mat-cell style="width: 100px;" *matCellDef="let row">
                {{(row.isCustomizedValue.State)}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="paymentStatus">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Payment Status</mat-header-cell>
              <mat-cell style="width: 100px;" *matCellDef="let row">
                {{ row.paymentStatus ?? 'Pending' }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="paid">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Paid</mat-header-cell>
              <mat-cell style="width: 100px;" *matCellDef="let row">
                {{ currencyConvertPipe.transform(row.paid ?? 0) }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="balance">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Balance</mat-header-cell>
              <mat-cell style="width: 100px;" *matCellDef="let row">
                {{ currencyConvertPipe.transform(row.balance ?? row.amount ?? 0) }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="amount">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Amount</mat-header-cell>
              <mat-cell style="width: 100px;" *matCellDef="let row">
                {{ currencyConvertPipe.transform(row.amount || 0) }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="stage">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Stage</mat-header-cell>
              <mat-cell style="width: 100px;" *matCellDef="let row">
                {{ row.stage}}
              </mat-cell>
            </ng-container>




            <!-- actions Column -->
            <ng-container matColumnDef="actions">
              <mat-header-cell class="actions-cell" *matHeaderCellDef>Action</mat-header-cell>
              <mat-cell class="actions-cell" *matCellDef="let row">
                <button [attr.guide]="sanitizedUrl + '-action-menu-btn'" type="button" mat-icon-button
                  [matMenuTriggerFor]="actionsMenu" (click)="$event.stopPropagation()">
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                  <button [attr.guide]="sanitizedUrl + '-edit-deal-btn'" [disabled]="!resourcePrivilege?.update"
                    (click)="editProduct(row.entityId,row.attributeSetId)" mat-menu-item>
                    <mat-icon>edit</mat-icon>
                    <span>edit</span>
                  </button>
                  <button [attr.guide]="sanitizedUrl + '-add-payment-btn'" [disabled]="row.paymentStatus == 'Paid'"
                    (click)="addPayment(row)" mat-menu-item>
                    <mat-icon>add</mat-icon>
                    <span>Add Payment</span>
                  </button>
                  <button [attr.guide]="sanitizedUrl + '-view-deals-payment-btn'"
                    (click)="ViewDealsPayment(row.entityId)" mat-menu-item>
                    <mat-icon>payment</mat-icon>
                    <span>View Deals Payment</span>
                  </button>

                  <button [attr.guide]="sanitizedUrl + '-delete-deal-btn'" [disabled]="!resourcePrivilege?.delete"
                    (click)="deleteAllProductId(row.entityId)" mat-menu-item>
                    <mat-icon>delete</mat-icon>
                    <span>delete</span>
                  </button>
                  <!-- <button [attr.guide]="sanitizedUrl + '-delete-customer-btn'" (click)="deleteCustomer(row)" mat-menu-item>
                      <span>Delete</span>
                    </button>  -->
                </mat-menu>
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="visibleColumns;sticky:true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: visibleColumns;">
            </mat-row>
          </table>
        </div>
        <div class="products-padding" fxLayoutAlign="center center"
          *ngIf="productList?.data?.length === 0 || productList?.length === 0">
          No records found
        </div>


        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px">
          <mat-spinner [diameter]="20" *ngIf="spinner"></mat-spinner>
          <mat-paginator [attr.guide]="sanitizedUrl + '-pagination'" class="paginator" (page)="getUpdate($event)"
            showFirstLastButtons [length]="pageList" [pageIndex]="page" [pageSize]="size"
            [pageSizeOptions]="pageSizeValue"> </mat-paginator>
        </div>
      </div>
    </calsoft-list>

  </div>


  <div class="custom-table gridtable-class" style="width: 100%;overflow-x: auto;"
    *ngIf="dealsPrimaryType == 0&&GridType>=8 "
    [class.filter-open-layout]="isFilterPanelOpen || isFilterPanelColumnOpen" fxLayout="row" [fxLayoutGap]="rowgap">

    <div [fxFlex]="rowLeft" *ngIf="isGridVisible" style="width: 100%;">
      <div class="crm-container-new-eight">

        <main class="main-content">
          <!-- <section class="sg-container" *ngIf="dealsTableView == 0">
          <div class="sg-header" fxLayout="row" fxLayoutAlign="space-between center">
            <div fxFlex>
              <h2 class="sg-title">{{(currentRouterPath | moduleName) || 'Deals'}}</h2>
            </div>

            <div class="top-nav" style="width: 100%" fxFlex="80%">

              <div class="top-nav-left">
                <calsoft-trial-exiped-message></calsoft-trial-exiped-message>

              </div>
              <div class="top-nav-right">
                <div class="search-bar">
                  <mat-icon>search</mat-icon>
                  <input [attr.guide]="sanitizedUrl + '-crm-search-input'" readonly (click)="goToPopUp()" type="text"
                    placeholder="Search your CRM" />
                </div>

              </div>
            </div>
          </div>

          <div class="sg-steps-navigation">


            <div class="sg-steps-wrapper" #stepsWrapper (scroll)="checkScrollPosition()">
              <div *ngFor="let step of setupSteps" class="sg-step" [attr.guide]="sanitizedUrl + '-step-' + step.label"
                [ngClass]="{
             'sg-step--active': step.status === 'active',
             'sg-step--completed': step.status === 'completed'
           }" (click)="onStepClick(step)">

                <div class="sg-icon-container" [ngClass]="'sg-icon-bg--' + step.icon">
                  <mat-icon>{{ step.icon }}</mat-icon>
                </div>

                <span class="sg-step-label">{{ step.label }}</span>

                <mat-icon *ngIf="step.status === 'completed'" class="sg-checkmark-icon">check_circle</mat-icon>
              </div>
            </div>


          </div>
        </section> -->

          <section class="contacts-view">
            <div class="contacts-header">

              <div>
                <h2 class="sg-title">{{(currentRouterPath | moduleName) || 'Deals'}}</h2>
              </div>


              <div class="contact-tabs" fxFlex="40" fxFlex.xs="100">


                <div *ngIf="tableViewMode === 'tableView'" class="tabs-controls">
                  <button [attr.guide]="sanitizedUrl + '-scroll-left-btn'" type="button" class="tab-arrow left"
                    (click)="scrollTabs('left', $event)" aria-label="Scroll left">
                    <mat-icon>chevron_left</mat-icon>
                  </button>

                  <div class="tabs-scroll" #tabsScroll>

                    <span class="tab-item" [attr.guide]="sanitizedUrl + '-all-deals-tab'"
                      [class.active]="activeTab === 'all'" (click)="onTabClick('all', $event)">
                      All Deals <span *ngIf="activeTab === 'all'" class="count">{{pageList}}</span>
                    </span>

                    <span *ngFor="let tab of smartViewList; let i = index" class="tab-item"
                      [attr.guide]="sanitizedUrl + '-' + tab.tabName + '-tab'"
                      [class.active]="activeTab === tab.tabName" (click)="onClickTabData(tab)">
                      {{tab.tabName}} <span class="count" *ngIf="activeTab === tab.tabName">{{pageList|| 0}}</span>
                    </span>

                  </div>

                  <button [attr.guide]="sanitizedUrl + '-scroll-right-btn'" type="button" class="tab-arrow right"
                    (click)="scrollTabs('right', $event)" aria-label="Scroll right">
                    <mat-icon>chevron_right</mat-icon>
                  </button>
                </div>

              </div>

              <div class="contact-actions">
                <button [attr.guide]="sanitizedUrl + '-refresh-btn'" class="btn btn-outline bhover" (click)="refresh()">
                  <mat-icon>refresh</mat-icon>
                  <i class="fa-solid fa-rotate-right"></i>
                  Refresh</button>
                <!-- <button [attr.guide]="sanitizedUrl + '-import-advance-deals-btn'" class="btn btn-outline" (click)="importExcelAdvance()"><mat-icon>cloud_upload</mat-icon>
                Import
                Advance Deals</button> -->
                <button [attr.guide]="sanitizedUrl + '-export-btn'" class="btn btn-outline bhover"
                  (click)="bulkUpload ? restritionPopup() : exportDataFilter()" *ngIf="!connectedCall">
                  <mat-icon>file_download</mat-icon>
                  Export
                </button>
                <button [attr.guide]="sanitizedUrl + '-add-deals-large-btn'" class="btn btn-primary"
                  (click)="addproduct()"><i class="fas fa-plus">
                    <mat-icon>add</mat-icon>
                  </i> Add Deals</button>
              </div>
            </div>

            <div class="table-controls-wrapper">

              <div class="table-controls" *ngIf="isSelectionEmpty()">
                <div class="contacts-header">
                  <div class="contact-actions">

                    <button [attr.guide]="sanitizedUrl + '-table-menu-btn'" class="btn btn-outline bhover" mat-button
                      [matMenuTriggerFor]="viewTableMenu"
                      style="justify-content: center;"><mat-icon>table_chart</mat-icon> Table </button>



                    <button [attr.guide]="sanitizedUrl + '-layers-btn'" *ngIf="tableViewMode === 'tableView'" mat-button
                      [matMenuTriggerFor]="viewMenu" class="btn-two btn-outline bhover">
                      <mat-icon>layers</mat-icon>
                    </button>

                    <button class="btn btn-outline bhover" [attr.guide]="sanitizedUrl + '-table-search-btn'"
                      (click)="goToPopUp()">
                      <mat-icon>search</mat-icon>
                    </button>

                    <!-- Dropdown Menu -->
                    <mat-menu #viewTableMenu="matMenu">
                      <button [attr.guide]="sanitizedUrl + '-table-view-menu-item'" mat-menu-item
                        (click)="setTableView('tableView')">
                        <mat-icon>table_chart</mat-icon>
                        <span style="margin-left: 8px;">Table View</span>

                        <mat-icon *ngIf="tableViewMode != 'kanbanView'">check</mat-icon>
                      </button>
                      <button [attr.guide]="sanitizedUrl + '-kanban-view-menu-item'" mat-menu-item
                        (click)="setTableView('kanbanView')">
                        <mat-icon>view_column</mat-icon>
                        <span style="margin-left: 8px;">Kanban View</span>
                        <mat-icon *ngIf="tableViewMode == 'kanbanView'">check</mat-icon>

                      </button>
                    </mat-menu>

                    <mat-menu #viewMenu="matMenu">
                      <button [attr.guide]="sanitizedUrl + '-compact-view-menu-item'" mat-menu-item
                        (click)="setView('compact')">
                        <i class="fas fa-compress"></i>
                        <span style="margin-left: 8px;">Compact</span>
                        <mat-icon *ngIf="viewMode === 'compact'" style="margin-left:5px;">check</mat-icon>
                      </button>
                      <button [attr.guide]="sanitizedUrl + '-comfortable-view-menu-item'" mat-menu-item
                        (click)="setView('comfortable')">
                        <i class="fas fa-expand"></i>
                        <span style="margin-left: 8px;">Comfortable</span>
                        <mat-icon *ngIf="viewMode === 'comfortable'" style="margin-left:5px;">check</mat-icon>
                      </button>
                    </mat-menu>

                    <button [attr.guide]="sanitizedUrl + '-bulk-actions-btn'" class="btn btn-outline bhover"
                      *ngIf="tableViewMode !== 'kanbanView'" (click)="selectAllForBulkAction()">Bulk actions</button>
                    <button [attr.guide]="sanitizedUrl + '-filter-btn'"
                      class="btn btn-outline bhover d-flex align-items-center gap-2"
                      [class.active-filter]="filterActive" (click)="toggleFilterPanel()">

                      <mat-icon class="me-1">
                        {{ filterActive ? 'filter_alt' : 'filter_list' }}
                      </mat-icon>

                      <span>Filter</span>

                      <span *ngIf="filterActive" class="filter-pill">
                        <mat-icon class="pill-icon">check_circle</mat-icon>

                      </span>
                    </button>

                    <ng-container *ngIf="resourcePrivilege?.delete">
                      <button [attr.guide]="sanitizedUrl + '-delete-all-large-btn'" class="btn btn-outline bhover"
                        [disabled]="!resourcePrivilege?.delete" (click)="deleteAllDialog()">
                        <mat-icon>delete_forever</mat-icon>
                        Delete All</button>
                    </ng-container>

                    <button [attr.guide]="sanitizedUrl + '-filter-columns-btn'" *ngIf="tableViewMode === 'tableView'"
                      class="btn btn-outline bhover" (click)="toggleFilterColumnPanel()"
                      [class.active-filter]="isFilterPanelColumnOpen">
                      Filter by Columns
                    </button>

                  </div>
                </div>
              </div>

              <div class="bulk-action-bar" *ngIf="!isSelectionEmpty()">
                <div class="contacts-header">
                  <div class="contact-actions">
                    <span class="selection-count">{{ getSelectedCount() }} selected</span>

                    <button [attr.guide]="sanitizedUrl + '-download-selected-btn'" class="btn btn-outline"
                      [disabled]="!resourcePrivilege?.update"
                      (click)="bulkUpload ? restritionPopup() : exportDataFilterSelected('selected')">Download
                      Selected</button>
                    <button [attr.guide]="sanitizedUrl + '-delete-selected-btn'" class="btn btn-outline"
                      [disabled]="!resourcePrivilege?.delete" (click)="deleteSelectedDialog()">Delete Selected </button>




                    <div class="cancel-action">
                      <button [attr.guide]="sanitizedUrl + '-cancel-bulk-selection-btn'" mat-button
                        (click)="cancelBulkSelection()">
                        <mat-icon>close</mat-icon> Cancel selection
                      </button>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="leads-content-area" [class.filter-open]="isFilterPanelOpen"
              [class.filter-column-open]="isFilterPanelColumnOpen">
              <div class="view-content">
                <div *ngIf="tableViewMode == 'tableView'">
                  <div class="table-wrapper">
                    <table mat-table [dataSource]="productList" matSort (matSortChange)="sortData($event)"
                      class="contacts-table" [ngClass]="viewMode">

                      <ng-container *ngFor="let col of columns" [sticky]="!isMobile && col.isSticky"
                        [matColumnDef]="col.property">
                        <ng-container *ngIf="col.isModelProperty!='false'">

                          <ng-container *ngIf="col.property !== 'actions'">
                            <ng-container *ngIf="col.property !== 'actions' && col.property !== 'action' ">
                              <th mat-header-cell *matHeaderCellDef mat-sort-header [appResizable]="col.property"
                                [tableId]="'deals-table-grid8'" storageStrategy="external"
                                [initialWidth]="columnWidths[col.property] || null"
                                (widthResized)="onColumnResized(col.property, $event)" style="min-width: 150px;">
                                {{ col.name }}
                              </th>
                            </ng-container>
                            <ng-container *ngIf="col.property === 'actions' || col.property === 'action'">
                              <th mat-header-cell *matHeaderCellDef class="actions-cell">
                                {{ col.name }}
                              </th>
                            </ng-container>
                          </ng-container>
                          <ng-container *ngIf="col.property === 'actions'">
                            <th mat-header-cell *matHeaderCellDef class="actions-cell" [appResizable]="'actions'"
                              [tableId]="'deals-table-grid8'" storageStrategy="external"
                              [initialWidth]="columnWidths['actions'] || null"
                              (widthResized)="onColumnResized('actions', $event)">
                              {{ col.name }}
                            </th>
                          </ng-container>

                          <td mat-cell *matCellDef="let element ;let i = index" class="hover-cell"
                            [style.maxWidth]="col.property !== 'dealsName' ? ((columnWidths[col.property] > 0 ? columnWidths[col.property] : 150) + 'px') : null"
                            [style.minWidth]="col.property !== 'dealsName' ? '150px' : null"
                            [ngClass]="{'hide-icons': (col.property !== 'actions' && col.property !== 'action') && columnWidths[col.property] < 250, 'hide-avatar': (col.property !== 'actions' && col.property !== 'action') && columnWidths[col.property] < 120}">
                            <div class="cell-content-wrapper">
                              <div class="cell-data" style="padding-left: 15px;">
                                <ng-container *ngIf="col.isModelProperty!='false'">


                                  <span *ngIf="col.property.includes('customValuesIs')">
                                    <!-- {{element.isCustomizedValue[col.propertyName] }} -->

                                  </span>
                                </ng-container>


                                <ng-container [ngSwitch]="col.property">
                                  <span *ngSwitchCase="'dealsName'" style="width: 100%;">
                                    <div class="user-cell" fxLayout="row" fxLayoutAlign="space-between center"
                                      style="width: 100%;">
                                      <div fxLayout="row" fxLayoutAlign="start center"
                                        style="flex: 1; overflow: hidden; min-width: 0;">
                                        <img *ngIf="element.avatarUrl" [src]="element.avatarUrl"
                                          class="contact-avatar" />
                                        <div *ngIf="!element.avatarUrl" class="contact-avatar owner-avatar"
                                          style="margin-right: 10px;">
                                          {{ getInitialsTwo(element.dealsName || element.ownerIdName) }}
                                        </div>
                                        <span (click)="openLeadPanel(element)" class="name-cell"
                                          [attr.guide]="'link-deal-name'"
                                          style="cursor:pointer; color: #002244; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-weight: 500;">
                                          {{ (element.dealsName || '(No Name)') | slice:0:20 }}
                                        </span>
                                      </div>
                                      <div class="cell-actions" fxLayout="row" fxLayoutAlign="end center"
                                        style="padding-left: 10px;">
                                        <button mat-icon-button [matTooltip]="isMobile ? '' : 'Open'"
                                          [matTooltipPosition]="isMobile ? '' : 'above'"
                                          (click)="openLeadPanel(element); $event.stopPropagation()"
                                          class="icon-color icon-hover">
                                          <mat-icon style="font-size: 17px; color: #002244;">open_in_new</mat-icon>
                                        </button>

                                        <!-- <button mat-icon-button [matTooltip]="isMobile ? '' : 'Send Whatsapp'"
                                          [matTooltipPosition]="isMobile ? '' : 'above'"
                                          (click)="phonewhatsapp(element); $event.stopPropagation()"
                                          class="icon-color icon-hover">
                                          <mat-icon style="font-size: 17px; margin-top: -8px; color: #002244;"
                                            [icIcon]="icWhatsapp"></mat-icon>
                                        </button> -->
                                      </div>
                                    </div>
                                  </span>
                                  <span *ngSwitchCase="'LeadName'">
                                    <ng-container *ngIf="editingCell?.rowId === element.entityId 
                               && editingCell?.colProperty === col.property; else nameReadMode">
                                      <input *ngIf="col.inputType === 'text'" matInput [(ngModel)]="element.dealsName"
                                        placeholder="Enter LeadName" />
                                      <mat-select style="width: 100px;" *ngIf="col.inputType === 'select'"
                                        [(ngModel)]="element[col.property]">
                                        <ng-container *ngIf="col.property == 'LeadName'">
                                          <mat-option *ngFor="let opt of filtereduserTypeList; let i=index;"
                                            [value]="opt.email">
                                            {{opt.email}}
                                          </mat-option>
                                        </ng-container>
                                      </mat-select>
                                      <mat-select style="width: 100px;" *ngIf="col.inputType === 'multiSelect'" multiple
                                        [(ngModel)]="element[col.property]">
                                        <ng-container *ngIf="col.property == 'ownerEmail'">
                                          <mat-option *ngFor="let opt of filtereduserTypeList; let i=index;"
                                            [value]="opt.email">
                                            {{opt.email}}
                                          </mat-option>
                                        </ng-container>
                                      </mat-select>
                                    </ng-container>
                                    <ng-template #nameReadMode>
                                      <div class="user-cell">
                                        <img *ngIf="element.avatarUrl" [src]="element.avatarUrl"
                                          class="contact-avatar" />
                                        <div *ngIf="!element.avatarUrl" class="contact-avatar owner-avatar">
                                          {{ getInitialsTwo(element.dealsName || element.ownerIdName) }}
                                        </div>
                                        <span class="name-cell">{{ element.dealsName || '(No Name)' }}</span>
                                      </div>
                                    </ng-template>
                                  </span>
                                  <span *ngSwitchCase="'ownerIdName'">
                                    <ng-container *ngIf="editingCell?.rowId === element.entityId 
                               && editingCell?.colProperty === col.property; else dealsOwnerReadMode">
                                      <mat-select style="width: 100px;" [(ngModel)]="element[col.property]">
                                        {{col.property}}
                                        <ng-container *ngIf="col.property == 'ownerIdName'">
                                          <mat-option (onSelectionChange)="onOwnerSelected($event,opt,element)"
                                            *ngFor="let opt of filtereduserTypeList; let i=index;" [value]="opt.email">
                                            {{opt.email}}
                                          </mat-option>
                                        </ng-container>
                                      </mat-select>
                                    </ng-container>
                                    <ng-template #dealsOwnerReadMode>
                                      <span class="user-cell user-lead-status"
                                        [style.background-color]="element.leadStatusColour"
                                        [style.color]="element.darkTextColor">
                                        <!-- {{ element.statusName }} -->
                                        {{ getStatusName(element.statusName) }}
                                      </span>
                                    </ng-template>
                                  </span>
                                  <span *ngSwitchCase="'select'">
                                    <mat-checkbox [attr.guide]="sanitizedUrl + '-checkbox-' + element.entityId"
                                      (click)="$event.stopPropagation()"
                                      (change)="changeValue($event.checked, element); $event ? selection.toggle(element) : null"
                                      [checked]="selection.isSelected(element) || isRowSelected(element)"
                                      [aria-label]="checkboxLabel(element)">
                                    </mat-checkbox>
                                  </span>
                                  <span *ngSwitchCase="'actions'">
                                    <button [attr.guide]="sanitizedUrl + '-action-menu-btn'" type="button"
                                      mat-icon-button [matMenuTriggerFor]="actionsMenu"
                                      (click)="$event.stopPropagation()">
                                      <mat-icon>more_horiz</mat-icon>
                                    </button>
                                    <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before"
                                      class="premium-action-menu">
                                      <button [attr.guide]="sanitizedUrl + '-edit-deal-btn'"
                                        [disabled]="!resourcePrivilege?.update"
                                        (click)="editProduct(element.entityId, element.attributeSetId)" mat-menu-item
                                        class="menu-item-edit">
                                        <mat-icon>edit</mat-icon>
                                        <span>Edit</span>
                                      </button>
                                      <button [attr.guide]="sanitizedUrl + '-add-payment-btn'"
                                        [disabled]="element.paymentStatus == 'Paid'" (click)="addPayment(element)"
                                        mat-menu-item class="menu-item-add-payment" class="menu-item-payment">
                                        <mat-icon>add</mat-icon>
                                        <span>Add Payment</span>
                                      </button>
                                      <button [attr.guide]="sanitizedUrl + '-view-deals-payment-btn'"
                                        (click)="ViewDealsPayment(element.entityId)" mat-menu-item
                                        class="menu-item-deals-payment">
                                        <mat-icon>payment</mat-icon>
                                        <span>View Deals Payment</span>
                                      </button>

                                      <button [attr.guide]="sanitizedUrl + '-delete-deal-btn'"
                                        [disabled]="!resourcePrivilege?.delete"
                                        (click)="deleteAllProductId(element.entityId)" mat-menu-item
                                        class="menu-item-delete">
                                        <mat-icon>delete</mat-icon>
                                        <span>delete</span>
                                      </button>

                                    </mat-menu>
                                  </span>
                                  <span *ngSwitchCase="'statusName'"><span class="status"
                                      [style.background-color]="element.leadStatusColour"
                                      [style.color]="element.darkTextColor">
                                      {{ element.statusName }}
                                    </span></span>
                                  <span *ngSwitchCase="'sourceName'">{{ element.sourceName || '--' }}</span>
                                  <span *ngSwitchCase="'phoneNumber'"><a href="">{{ element.phoneNumber || '--'
                                      }}</a></span>
                                  <span *ngSwitchCase="'CrNo_cust'">{{ element.isCustomizedValue.CrNo }}</span>
                                  <span *ngSwitchCase="'CrName_cust'">{{ element.isCustomizedValue.CrName }}</span>
                                  <span *ngSwitchCase="'leadName'" (click)="goToLead(element)"> {{ element.leadName ||
                                    '--'
                                    }}</span>
                                  <span *ngSwitchCase="'amount'">{{currencyConvertPipe.transform(element.amount ||
                                    '--')}}</span>
                                  <span *ngSwitchCase="'Probability'">{{ element.probability || '--'}}</span>
                                  <span *ngSwitchCase="'deal'"> {{ element.deal || 'Open'}}</span>
                                  <span *ngSwitchCase="'stage'">
                                    <ng-container *ngIf="editingCell?.rowId === element.entityId 
                               && editingCell?.colProperty === col.property; else stageReadMode">
                                      <mat-select style="width: 100px;" *ngIf="col.inputType === 'select'"
                                        [(ngModel)]="element[col.property]">
                                        <ng-container *ngIf="col.property == 'stage'">
                                          <mat-option *ngFor="let opt of filteredleadStatusTypeList; let i=index;"
                                            [value]="opt.statusId">
                                            {{opt.statusName}}
                                          </mat-option>
                                        </ng-container>
                                      </mat-select>
                                    </ng-container>
                                    <ng-template #stageReadMode>
                                      <span class="user-cell user-lead-status"
                                        [style.background-color]="element.leadStatusColour"
                                        [style.color]="element.darkTextColor">
                                        {{ getStatusName(element.stage) }}
                                      </span>
                                    </ng-template>
                                  </span>
                                  <span *ngSwitchCase="'status'"> {{ element.status }}</span>
                                  <span *ngSwitchCase="'Payment Status'"> {{ element.paymentStatus || '--'}}</span>
                                  <span *ngSwitchCase="'closingDate'">{{ element.closingDate | date:'dd-MM-yyyy'
                                    }}</span>
                                  <span *ngSwitchCase="'expectedClosingDate'">{{ element.expectedClosingDate |
                                    date:'dd-MM-yyyy' }}</span>
                                  <span *ngSwitchCase="'leadCreatedDate'">{{ element.leadCreatedDate | date:'dd-MM-yyyy'
                                    }}</span>
                                  <span *ngSwitchCase="'updatedDate'">{{ element.updatedDate | date:'medium' }}</span>
                                  <span *ngSwitchCase="'createdDate'">{{ element.createdDate | date:'medium' }}</span>
                                  <span *ngSwitchCase="'ownerEmail'">{{ element.ownerEmail || element.dealsOwner || '--'
                                    }}</span>
                                  <span *ngSwitchCase="'dealsOwner'">{{ element.dealsOwner || element.ownerEmail || '--'
                                    }}</span>
                                  <span *ngSwitchCase="'owner'">{{ element.dealsOwner || element.ownerEmail ||
                                    element.owner || '--' }}</span>
                                  <span *ngSwitchCase="'paid'">{{ currencyConvertPipe.transform(element.paid ?? 0)
                                    }}</span>
                                  <span *ngSwitchCase="'Paid'">{{ currencyConvertPipe.transform(element.paid ?? 0)
                                    }}</span>
                                  <span *ngSwitchCase="'balance'">{{ currencyConvertPipe.transform(element.balance ??
                                    element.amount ?? 0) }}</span>
                                  <span *ngSwitchCase="'Balance'">{{ currencyConvertPipe.transform(element.balance ??
                                    element.amount ?? 0) }}</span>
                                  <span *ngSwitchCase="'paymentStatus'">{{ element.paymentStatus || '--'}}</span>
                                  <span *ngSwitchCase="'reasonForLoss'">{{ element.reasonForLoss || '--'}}</span>
                                  <span *ngSwitchDefault>
                                    <ng-container *ngIf="editingCell?.rowId === element.entityId 
                               && editingCell?.colProperty === col.property; else readMode">
                                      <input *ngIf="col.inputType === 'text'" matInput
                                        [(ngModel)]="element[col.property]" placeholder="Enter value" />
                                      <mat-select style="width: 100px;" *ngIf="col.inputType === 'select'"
                                        [(ngModel)]="element[col.property]">
                                        <ng-container
                                          *ngIf="col.property == 'ownerEmail' || col.property == 'dealsOwner' || col.property == 'owner'">
                                          <mat-option *ngFor="let opt of filtereduserTypeList; let i=index;"
                                            [value]="opt.email">
                                            {{opt.email}}
                                          </mat-option>
                                        </ng-container>
                                      </mat-select>
                                      <mat-select style="width: 100px;" *ngIf="col.inputType === 'multiSelect'" multiple
                                        [(ngModel)]="element[col.property]">
                                        <ng-container
                                          *ngIf="col.property == 'ownerEmail' || col.property == 'dealsOwner' || col.property == 'owner'">
                                          <mat-option *ngFor="let opt of filtereduserTypeList; let i=index;"
                                            [value]="opt.email">
                                            {{opt.email}}
                                          </mat-option>
                                        </ng-container>
                                      </mat-select>
                                    </ng-container>
                                    <ng-template #readMode>
                                      <span *ngIf="col.property.includes('customValuesIs'); else normalField">
                                        {{ element.isCustomizedValue[col.propertyName] }}
                                      </span>
                                      <ng-template #normalField>
                                        {{ element[col.property] || '--' }}
                                      </ng-template>
                                    </ng-template>
                                  </span>
                                  <span *ngSwitchCase="'company'">
                                    <ng-container *ngIf="editingCell?.rowId === element.entityId 
                             && editingCell?.colProperty === col.property; else companyReadMode">
                                      <input *ngIf="col.inputType === 'text'" matInput [(ngModel)]="element.company"
                                        (input)="getCompanyData(element.company)" [matAutocomplete]="auto"
                                        placeholder="Enter Company" />
                                      <mat-autocomplete #auto="matAutocomplete">
                                        <mat-option (onSelectionChange)="onCompanySelected($event,opt,element)"
                                          *ngFor="let opt of companyList" [value]="opt.name">
                                          {{ opt.name }}
                                        </mat-option>
                                      </mat-autocomplete>
                                    </ng-container>
                                    <ng-template #companyReadMode>
                                      <span class="user-cell" (click)="goToCompany(element)">
                                        {{ element.company }}
                                      </span>
                                    </ng-template>
                                  </span>
                                  <span *ngSwitchCase="'lead'">
                                    <ng-container *ngIf="editingCell?.rowId === element.entityId 
                             && editingCell?.colProperty === col.property; else leadReadMode">
                                      <input *ngIf="col.inputType === 'text'" matInput [(ngModel)]="element.lead"
                                        (input)="getLeadData(element.lead)" [matAutocomplete]="auto"
                                        placeholder="Enter Lead" />
                                      <mat-autocomplete #auto="matAutocomplete">
                                        <mat-option (onSelectionChange)="onLeadSelected($event,opt,element)"
                                          *ngFor="let opt of leadList" [value]="opt.name">
                                          {{ opt.name }}
                                        </mat-option>
                                      </mat-autocomplete>
                                    </ng-container>
                                    <ng-template #leadReadMode>
                                      <span class="user-cell">
                                        {{ element.LeadName }}
                                      </span>
                                    </ng-template>
                                  </span>
                                </ng-container>
                              </div>
                            </div>
                          </td>
                        </ng-container>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="visibleColumns;sticky:true"></tr>
                      <tr mat-row *matRowDef="let row; columns: visibleColumns;">
                      </tr>

                    </table>
                    <div style="padding: 20px;" fxLayoutAlign="center center"
                      *ngIf="productList?.data?.length === 0 || productList?.length === 0">
                      No records found
                    </div>


                  </div>

                  <mat-paginator [attr.guide]="sanitizedUrl + '-pagination-bottom'" class="paginator sticky-paginator"
                    (page)="getUpdate($event)" showFirstLastButtons [length]="pageList" [pageIndex]="page"
                    [pageSize]="size" [pageSizeOptions]="pageSizeValue">
                  </mat-paginator>
                </div>

                <div *ngIf="viewType === 'kanban' || tableViewMode == 'kanbanView'">
                  <calsoft-dealskanban></calsoft-dealskanban>
                </div>
              </div>
            </div>

          </section>

        </main>
      </div>
    </div>

    <!-- Filter Panel Side Form Container -->
    <div class="side-form-container" *ngIf="isFilterPanelOpen" [fxFlex]="rowRight">
      <div class="side-form-card mat-elevation-z4" style="height: 100%;">
        <div style="flex: 1; display: flex; flex-direction: column; overflow: hidden; min-height: 0;">
          <calsoft-filter-list-popup
            style="display: flex; flex-direction: column; flex: 1; min-height: 0; height: 100%;" [type]="1"
            [columns]="columns" [filterSelectObj]="filterSelectObj"
            (filterChangeColumn)="onFilterChangeColumn($event, 1)" [name]="'Deals'"
            (closePopup)="closePopupNew($event)"></calsoft-filter-list-popup>
        </div>
      </div>
    </div>

    <!-- Column Visibility Filter Panel Side Form Container -->
    <div class="side-form-container" *ngIf="isFilterPanelColumnOpen" [fxFlex]="rowRight">
      <div class="side-form-card mat-elevation-z4" style="height: 100%;">
        <div class="side-form-header" fxLayout="row" fxLayoutAlign="space-between center">
          <div class="title-area" fxLayout="row" fxLayoutAlign="space-between center">
            <h3 style="margin: 0; margin-left: 5px;">Filter By Column</h3>
          </div>
          <button mat-icon-button (click)="toggleFilterColumnPanel()" aria-label="Close filter panel"
            [attr.guide]="sanitizedUrl + '-btn-close-filter-column'">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="side-form-content">
          <calsoft-column-visibility [columns]="columns" [filterType]="true"
            (filterChangeColumn)="onFilterChangeColumn($event, 1)"
            (closePopup)="closePopupTwo($event)"></calsoft-column-visibility>
        </div>
      </div>
    </div>

  </div>


</div>

<ng-template #deleteSelected>
  <div class="index-head">
    <span>Delete Selected Deals</span>
  </div>

  <div class="padding-index">
    <span>
      Are you sure you want to delete the selected deals? This action cannot be undone.
    </span>
  </div>

  <div class="buttonpadding" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">

    <button mat-raised-button mat-dialog-close (click)="submit1()" [disabled]="textAccount != 'OK'">
      Cancel
    </button>

    <button mat-raised-button [disabled]="textAccount != 'OK'" (click)="deleteSelectedLead()">
      {{textAccount != 'Processing' ? 'Delete Selected' : 'Processing'}}
      <mat-icon *ngIf="textAccount != 'OK'">
        <mat-spinner color="primary" diameter="20"></mat-spinner>
      </mat-icon>
    </button>
  </div>
</ng-template>

<ng-template #delete>

  <div class="index-head">
    <span>Delete All Deals</span>
  </div>

  <div class="padding-index">
    <span>
      Do you want to delete all deals? This action cannot be undone.
    </span>
  </div>

  <div class="buttonpadding" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">

    <button mat-raised-button mat-dialog-close (click)="submit1()" [disabled]="textAccount != 'OK'">
      Cancel
    </button>

    <button mat-raised-button [disabled]="textAccount != 'OK'" (click)="submit()">
      {{textAccount != 'Processing' ? 'Delete All' : 'Processing'}}
      <mat-icon *ngIf="textAccount != 'OK'">
        <mat-spinner color="primary" diameter="20"></mat-spinner>
      </mat-icon>
    </button>

  </div>
</ng-template>

<ng-template #delete1>
  <!-- <div class="modal-content">
    <div class="modal-header" fxLayout="row" fxLayoutAlign="space-between center">
      <h2 class="modal-title">Delete Deal</h2>
      <button mat-icon-button mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="modal-body">
      <p>Are you sure you want to delete this deal?</p>
    </div>
    <div class="modal-footer" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
      <button mat-raised-button mat-dialog-close class="btn-cancel">Cancel</button>
      <button mat-raised-button (click)="deleteAllProductId(id)" class="btn-delete">Delete</button>
    </div>
  </div> -->
  <div class="index-head">
    <span>Delete Deal</span>
  </div>

  <div class="padding-index">
    <span>
      Are you sure you want to delete this deal?
    </span>
  </div>

  <div class="buttonpadding" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">

    <button mat-raised-button mat-dialog-close (click)="submit1()">
      Cancel
    </button>

    <button mat-raised-button (click)="deleteAllProductId(id)">
      Delete
    </button>
  </div>
</ng-template>

<ng-template #download>
  <div class="modal-content">
    <div class="modal-header" fxLayout="row" fxLayoutAlign="space-between center">
      <h2 class="modal-title">Download Deals</h2>
      <button mat-icon-button mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="modal-body">
      <form [formGroup]="firstFormGroup" fxLayout="column" fxLayoutGap="10px" style="padding: 10px;">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Page</mat-label>
          <input matInput formControlName="page" type="number">
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Size</mat-label>
          <input matInput formControlName="size" type="number">
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Sort By</mat-label>
          <mat-select formControlName="sort">
            <!-- Example sort options -->
            <mat-option value="dealsName">Deals Name</mat-option>
            <mat-option value="amount">Amount</mat-option>
            <mat-option value="stage">Stage</mat-option>
            <mat-option value="createdDate">Created Date</mat-option>
          </mat-select>
        </mat-form-field>
      </form>
    </div>
    <div class="modal-footer" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
      <button mat-raised-button mat-dialog-close class="btn-cancel">Cancel</button>
      <button mat-raised-button color="primary" (click)="downloadData()" class="btn-download">Download</button>
    </div>
  </div>
</ng-template>